// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3iDud","head":"Table_head__1NDev","col":"Table_col__39UkD"};